/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
/*CSS-START*/
/* icon vars */
:host {
  --icon-font-family: var(--icon-font-family-theme, "pepmdx");
}

/* di stands for Disney Icon */
.di {
  font-family: var(--icon-font-family, "pepmdx") !important;
  font-style: normal;
  font-size: inherit;
}

.di50 {
  font-size: 50px;
}

.di40 {
  font-size: 40px;
}

.di36 {
  font-size: 36px;
}

.di28 {
  font-size: 28px;
}

.di24 {
  font-size: 24px;
}

.di20 {
  font-size: 20px;
}

.di18 {
  font-size: 18px;
}

.di16 {
  font-size: 16px;
}

.di14 {
  font-size: 14px;
}

.di12 {
  font-size: 12px;
}

.di10 {
  font-size: 10px;
}

.di-disney-resort::before, .di-E001::before {
  content: '\\E001';
}

.di-california-adventure::before, .di-E002::before {
  content: '\\E002';
}

.di-disney-paris::before, .di-E003::before {
  content: '\\E003';
}

.di-shanghai-disney-resort::before, .di-E004::before {
  content: '\\E004';
}

.di-hong-kong-disney::before, .di-E005::before {
  content: '\\E005';
}

.di-tokyo-disney::before, .di-E006::before {
  content: '\\E006';
}

.di-aulani-resort-hawaii::before, .di-E007::before {
  content: '\\E007';
}

.di-adventure-by-disney::before, .di-E008::before {
  content: '\\E008';
}

.di-disney-park-generic-castle::before, .di-E009::before {
  content: '\\E009';
}

.di-leadership::before, .di-E00A::before {
  content: '\\E00A';
}

.di-selection-training::before, .di-E00B::before {
  content: '\\E00B';
}

.di-quality-service::before, .di-E00C::before {
  content: '\\E00C';
}

.di-brand-royalty::before, .di-E00D::before {
  content: '\\E00D';
}

.di-creativity-innovate::before, .di-E00E::before {
  content: '\\E00E';
}

.di-business-excellence::before, .di-E00F::before {
  content: '\\E00F';
}

.di-medical-excellence::before, .di-E010::before {
  content: '\\E010';
}

.di-catalogs::before, .di-E011::before {
  content: '\\E011';
}

.di-disney-park::before, .di-E012::before {
  content: '\\E012';
}

.di-disneyland-resort::before, .di-E013::before {
  content: '\\E013';
}

.di-city-hall-services::before, .di-E014::before {
  content: '\\E014';
}

.di-hkdl-magic-access::before, .di-E015::before {
  content: '\\E015';
}

.di-downtown-disney::before, .di-E016::before {
  content: '\\E016';
}

.di-wedding-engagements::before, .di-E017::before {
  content: '\\E017';
}

.di-weddings-ever-after-blog::before, .di-E018::before {
  content: '\\E018';
}

.di-weddings-bridal-boutique::before, .di-E019::before {
  content: '\\E019';
}

.di-shdr-disneytown::before, .di-E01A::before {
  content: '\\E01A';
}

.di-shdr-wishing-star-park::before, .di-E01B::before {
  content: '\\E01B';
}

.di-shop-disney-parks-app::before, .di-E01C::before {
  content: '\\E01C';
}

.di-shop-disney-parks-bag::before, .di-E01D::before {
  content: '\\E01D';
}

.di-shop-disney-bag::before, .di-E01E::before {
  content: '\\E01E';
}

.di-style-guide::before, .di-E020::before {
  content: '\\E020';
}

.di-star-wars::before, .di-E021::before {
  content: '\\E021';
}

.di-sw-galaxys-edge-hub::before, .di-E022::before {
  content: '\\E022';
}

.di-rundisney-medals::before, .di-E023::before {
  content: '\\E023';
}

.di-rundisney-shirts::before, .di-E024::before {
  content: '\\E024';
}

.di-rundisney-snacks::before, .di-E025::before {
  content: '\\E025';
}

.di-disneyland-calender::before, .di-E026::before {
  content: '\\E026';
}

.di-california-adventure-calender::before, .di-E027::before {
  content: '\\E027';
}

.di-genie-product::before, .di-E028::before {
  content: '\\E028';
}

.di-all-parks-and-resorts::before, .di-E040::before {
  content: '\\E040';
}

.di-magic-kingdom::before, .di-E041::before {
  content: '\\E041';
}

.di-epcot::before, .di-E042::before {
  content: '\\E042';
}

.di-animal-kingdom::before, .di-E043::before {
  content: '\\E043';
}

.di-hollywood-studios::before, .di-E044::before {
  content: '\\E044';
}

.di-typhoon-lagoon::before, .di-E045::before {
  content: '\\E045';
}

.di-blizzard-beach::before, .di-E046::before {
  content: '\\E046';
}

.di-disney-springs::before, .di-E047::before {
  content: '\\E047';
}

.di-espn-wide-world-sports::before, .di-E048::before {
  content: '\\E048';
}

.di-resorts::before, .di-E049::before {
  content: '\\E049';
}

.di-disney-beach-resorts::before, .di-E04A::before {
  content: '\\E04A';
}

.di-disney-boardwalk::before, .di-E04B::before {
  content: '\\E04B';
}

.di-all-categories::before, .di-E04C::before {
  content: '\\E04C';
}

.di-cirque-du-soleil-la-nouba::before, .di-E04D::before {
  content: '\\E04D';
}

.di-star-wars-galactic-starcruiser::before, .di-E04E::before {
  content: '\\E04E';
}

.di-disney-cruise-line::before, .di-E080::before {
  content: '\\E080';
}

.di-dcl-our-ships::before, .di-E081::before {
  content: '\\E081';
}

.di-dcl-destinations::before, .di-E082::before {
  content: '\\E082';
}

.di-dcl-onboard-fun::before, .di-E083::before {
  content: '\\E083';
}

.di-dcl-new-cruisers::before, .di-E084::before {
  content: '\\E084';
}

.di-dcl-port-adventures::before, .di-E085::before {
  content: '\\E085';
}

.di-app-instructions::before, .di-E086::before {
  content: '\\E086';
}

.di-featured-article::before, .di-E087::before {
  content: '\\E087';
}

.di-drink-of-the-day::before, .di-E088::before {
  content: '\\E088';
}

.di-view-folio::before, .di-E08A::before {
  content: '\\E08A';
}

.di-key-to-the-world::before, .di-E08B::before {
  content: '\\E08B';
}

.di-in-room-entertainment::before, .di-E08C::before {
  content: '\\E08C';
}

.di-ship-directory::before, .di-E08D::before {
  content: '\\E08D';
}

.di-theatre::before, .di-E08E::before {
  content: '\\E08E';
}

.di-disembarkation::before, .di-E08F::before {
  content: '\\E08F';
}

.di-wash-hands::before, .di-E094::before {
  content: '\\E094';
}

.di-security-notice::before, .di-E095::before {
  content: '\\E095';
}

.di-environmental-message::before, .di-E096::before {
  content: '\\E096';
}

.di-room-upgrade::before, .di-E098::before {
  content: '\\E098';
}

.di-castaway-club-member::before, .di-E09A::before {
  content: '\\E09A';
}

.di-dcl-open-house::before, .di-E09B::before {
  content: '\\E09B';
}

.di-stateroom-balcony::before, .di-E09F::before {
  content: '\\E09F';
}

.di-cart-empty::before, .di-E0C0::before {
  content: '\\E0C0';
}

.di-cart-full::before, .di-E0C1::before {
  content: '\\E0C1';
}

.di-tickets::before, .di-E0C2::before {
  content: '\\E0C2';
}

.di-fastpass-plus::before, .di-E0C3::before {
  content: '\\E0C3';
}

.di-fastpasses-set::before, .di-E0C4::before {
  content: '\\E0C4';
}

.di-fastpasses-copy-set::before, .di-E0C5::before {
  content: '\\E0C5';
}

.di-cancel-fastpasses::before, .di-E0C6::before {
  content: '\\E0C6';
}

.di-water-park::before, .di-E0C7::before {
  content: '\\E0C7';
}

.di-vacation-packages::before, .di-E0C8::before {
  content: '\\E0C8';
}

.di-personal-magic::before, .di-E0C9::before {
  content: '\\E0C9';
}

.di-florida-resident::before, .di-E0CA::before {
  content: '\\E0CA';
}

.di-disney-vacation-club-info::before, .di-E0CB::before {
  content: '\\E0CB';
}

.di-annual-passholder::before, .di-E0CC::before {
  content: '\\E0CC';
}

.di-us-military::before, .di-E0CD::before {
  content: '\\E0CD';
}

.di-special-offers-dollar-sign::before, .di-E0CE::before {
  content: '\\E0CE';
}

.di-booking-rooms-packages::before, .di-E0CF::before {
  content: '\\E0CF';
}

.di-old-fastpass::before, .di-E0D0::before {
  content: '\\E0D0';
}

.di-certificate::before, .di-E0D1::before {
  content: '\\E0D1';
}

.di-will-call-tickets::before, .di-E0D2::before {
  content: '\\E0D2';
}

.di-entrance-pass::before, .di-E0D3::before {
  content: '\\E0D3';
}

.di-guest-pass::before, .di-E0D4::before {
  content: '\\E0D4';
}

.di-city-pass::before, .di-E0D5::before {
  content: '\\E0D5';
}

.di-california::before, .di-E0D6::before {
  content: '\\E0D6';
}

.di-southern-california::before, .di-E0D7::before {
  content: '\\E0D7';
}

.di-etickets::before, .di-E0D8::before {
  content: '\\E0D8';
}

.di-compare-offers::before, .di-E0D9::before {
  content: '\\E0D9';
}

.di-baja-california-resident::before, .di-E0DA::before {
  content: '\\E0DA';
}

.di-area-attractions::before, .di-E0DB::before {
  content: '\\E0DB';
}

.di-anaheim-resort-transit::before, .di-E0DC::before {
  content: '\\E0DC';
}

.di-edit-fastpass::before, .di-E0DD::before {
  content: '\\E0DD';
}

.di-in-park-merchandise::before, .di-E0E0::before {
  content: '\\E0E0';
}

.di-travel-insurance::before, .di-E0E1::before {
  content: '\\E0E1';
}

.di-texas-resident::before, .di-E0E2::before {
  content: '\\E0E2';
}

.di-canadian-resident::before, .di-E0E3::before {
  content: '\\E0E3';
}

.di-add-tickets::before, .di-E0E4::before {
  content: '\\E0E4';
}

.di-splurge::before, .di-E0E5::before {
  content: '\\E0E5';
}

.di-disneyland-annual-passes::before, .di-E0E6::before {
  content: '\\E0E6';
}

.di-dlr-tickets-passes::before, .di-E0E7::before {
  content: '\\E0E7';
}

.di-get-vacation-offer-recommended::before, .di-E0E8::before {
  content: '\\E0E8';
}

.di-get-vacation-offer-guest-created::before, .di-E0E9::before {
  content: '\\E0E9';
}

.di-shdr-fastpass::before, .di-E0EA::before {
  content: '\\E0EA';
}

.di-currency-convertor::before, .di-E0EB::before {
  content: '\\E0EB';
}

.di-call-to-buy-tickets::before, .di-E0EC::before {
  content: '\\E0EC';
}

.di-wdw-tickets-and-passes::before, .di-E0ED::before {
  content: '\\E0ED';
}

.di-renew-annual-pass::before, .di-E0EE::before {
  content: '\\E0EE';
}

.di-renew-annual-pass-dlr::before, .di-E0EF::before {
  content: '\\E0EF';
}

.di-annual-pass-wdw::before, .di-E0F0::before {
  content: '\\E0F0';
}

.di-mobile-order::before, .di-E0F1::before {
  content: '\\E0F1';
}

.di-fastpass::before, .di-E0F2::before {
  content: '\\E0F2';
}

.di-ticket-ap-upgrade::before, .di-E0F3::before {
  content: '\\E0F3';
}

.di-shdr-premium-access::before, .di-E0F4::before {
  content: '\\E0F4';
}

.di-shdr-tickets-and-passes::before, .di-E0F5::before {
  content: '\\E0F5';
}

.di-shdr-seasonal-pass::before, .di-E0F6::before {
  content: '\\E0F6';
}

.di-shdr-fastpass-reverse::before, .di-E0F7::before {
  content: '\\E0F7';
}

.di-disney-maxpass::before, .di-E0F8::before {
  content: '\\E0F8';
}

.di-shdr-premium-access-chinese::before, .di-E0F9::before {
  content: '\\E0F9';
}

.di-hawaii-resident::before, .di-E0FA::before {
  content: '\\E0FA';
}

.di-club-33-membership::before, .di-E0FB::before {
  content: '\\E0FB';
}

.di-order-grocery-delivery::before, .di-E0FC::before {
  content: '\\E0FC';
}

.di-special-offers::before, .di-E0FD::before {
  content: '\\E0FD';
}

.di-prebook-fastpass::before, .di-E0FE::before {
  content: '\\E0FE';
}

.di-upgrade-offer::before, .di-E0FF::before {
  content: '\\E0FF';
}

.di-mdx::before, .di-E100::before {
  content: '\\E100';
}

.di-about-me::before, .di-E101::before {
  content: '\\E101';
}

.di-friends-family::before, .di-E102::before {
  content: '\\E102';
}

.di-account-settings::before, .di-E103::before {
  content: '\\E103';
}

.di-magicbands-v2::before, .di-E104::before {
  content: '\\E104';
}

.di-magic-cards::before, .di-E105::before {
  content: '\\E105';
}

.di-pin-payment-methods::before, .di-E106::before {
  content: '\\E106';
}

.di-communication-references::before, .di-E107::before {
  content: '\\E107';
}

.di-wishlist::before, .di-E108::before {
  content: '\\E108';
}

.di-link-existing-reservation::before, .di-E109::before {
  content: '\\E109';
}

.di-guest-entered-schedule-item::before, .di-E10A::before {
  content: '\\E10A';
}

.di-birthday::before, .di-E10B::before {
  content: '\\E10B';
}

.di-memory-maker::before, .di-E10C::before {
  content: '\\E10C';
}

.di-memory-maker-2::before, .di-E10D::before {
  content: '\\E10D';
}

.di-passes-and-memberships::before, .di-E10E::before {
  content: '\\E10E';
}

.di-link-mdx-tickets-passes::before, .di-E10F::before {
  content: '\\E10F';
}

.di-link-mdx-resort-reservations::before, .di-E110::before {
  content: '\\E110';
}

.di-link-mdx-dining-reservations::before, .di-E111::before {
  content: '\\E111';
}

.di-link-dlr-tickets::before, .di-E112::before {
  content: '\\E112';
}

.di-link-main-entrance::before, .di-E113::before {
  content: '\\E113';
}

.di-digital-key::before, .di-E115::before {
  content: '\\E115';
}

.di-wishlist-item-added::before, .di-E116::before {
  content: '\\E116';
}

.di-wishlist-empty::before, .di-E117::before {
  content: '\\E117';
}

.di-magicbands-original::before, .di-E118::before {
  content: '\\E118';
}

.di-all-activities::before, .di-E140::before {
  content: '\\E140';
}

.di-attractions::before, .di-E141::before {
  content: '\\E141';
}

.di-characters::before, .di-E142::before {
  content: '\\E142';
}

.di-entertainment::before, .di-E143::before {
  content: '\\E143';
}

.di-tours-events::before, .di-E144::before {
  content: '\\E144';
}

.di-in-park-shopping::before, .di-E145::before {
  content: '\\E145';
}

.di-spas::before, .di-E146::before {
  content: '\\E146';
}

.di-tour::before, .di-E14C::before {
  content: '\\E14C';
}

.di-spring-break::before, .di-E14D::before {
  content: '\\E14D';
}

.di-fireworks::before, .di-E14E::before {
  content: '\\E14E';
}

.di-shows::before, .di-E14F::before {
  content: '\\E14F';
}

.di-dining::before, .di-E180::before {
  content: '\\E180';
}

.di-dining-plan::before, .di-E181::before {
  content: '\\E181';
}

.di-dining-plan-accepted::before, .di-E182::before {
  content: '\\E182';
}

.di-dining-plan-not-accepted::before, .di-E183::before {
  content: '\\E183';
}

.di-dining-reservation::before, .di-E184::before {
  content: '\\E184';
}

.di-menu::before, .di-E185::before {
  content: '\\E185';
}

.di-prix-fixe-qsr::before, .di-E186::before {
  content: '\\E186';
}

.di-prix-fixe-tsr::before, .di-E187::before {
  content: '\\E187';
}

.di-entrees-qsr::before, .di-E188::before {
  content: '\\E188';
}

.di-entrees-tsr::before, .di-E189::before {
  content: '\\E189';
}

.di-beverages::before, .di-E18A::before {
  content: '\\E18A';
}

.di-wine::before, .di-E18B::before {
  content: '\\E18B';
}

.di-beer::before, .di-E18C::before {
  content: '\\E18C';
}

.di-cocktails::before, .di-E18D::before {
  content: '\\E18D';
}

.di-appetizers::before, .di-E18E::before {
  content: '\\E18E';
}

.di-sandwiches::before, .di-E18F::before {
  content: '\\E18F';
}

.di-beef-pork-chicken::before, .di-E190::before {
  content: '\\E190';
}

.di-seafood::before, .di-E191::before {
  content: '\\E191';
}

.di-pasta::before, .di-E192::before {
  content: '\\E192';
}

.di-salads::before, .di-E193::before {
  content: '\\E193';
}

.di-sides::before, .di-E194::before {
  content: '\\E194';
}

.di-desserts::before, .di-E195::before {
  content: '\\E195';
}

.di-buffet::before, .di-E196::before {
  content: '\\E196';
}

.di-favorites::before, .di-E197::before {
  content: '\\E197';
}

.di-kids-picks::before, .di-E198::before {
  content: '\\E198';
}

.di-featured-items::before, .di-E199::before {
  content: '\\E199';
}

.di-nutritional-content::before, .di-E19A::before {
  content: '\\E19A';
}

.di-nutritional-information::before, .di-E19B::before {
  content: '\\E19B';
}

.di-gluten-free::before, .di-E19C::before {
  content: '\\E19C';
}

.di-dairy-free::before, .di-E19D::before {
  content: '\\E19D';
}

.di-character-dining::before, .di-E19E::before {
  content: '\\E19E';
}

.di-mockey-food-seal::before, .di-E19F::before {
  content: '\\E19F';
}

.di-priority-seating::before, .di-E1A1::before {
  content: '\\E1A1';
}

.di-vegetarian::before, .di-E1A2::before {
  content: '\\E1A2';
}

.di-raw-food::before, .di-E1A3::before {
  content: '\\E1A3';
}

.di-guest-favorite-food::before, .di-E1A4::before {
  content: '\\E1A4';
}

.di-mobile-order-food::before, .di-E1A5::before {
  content: '\\E1A5';
}

.di-adult-table-service::before, .di-E1A6::before {
  content: '\\E1A6';
}

.di-celebration-cakes::before, .di-E1A7::before {
  content: '\\E1A7';
}

.di-disney-dining-plan::before, .di-E1A8::before {
  content: '\\E1A8';
}

.di-disney-deluxe-dining-plan::before, .di-E1A9::before {
  content: '\\E1A9';
}

.di-coffee-mug::before, .di-E1AA::before {
  content: '\\E1AA';
}

.di-mobile-order-food::before, .di-E1AB::before {
  content: '\\E1AB';
}

.di-qs-dining-card::before, .di-E1AC::before {
  content: '\\E1AC';
}

.di-allergy-friendly::before, .di-E1AD::before {
  content: '\\E1AD';
}

.di-kids-meals::before, .di-E1AE::before {
  content: '\\E1AE';
}

.di-dining-check-in::before, .di-E1AF::before {
  content: '\\E1AF';
}

.di-sports-recreation::before, .di-E1C0::before {
  content: '\\E1C0';
}

.di-campfire::before, .di-E1C1::before {
  content: '\\E1C1';
}

.di-snorkeling::before, .di-E1C2::before {
  content: '\\E1C2';
}

.di-swimming::before, .di-E1C3::before {
  content: '\\E1C3';
}

.di-boating::before, .di-E1C4::before {
  content: '\\E1C4';
}

.di-running::before, .di-E1C5::before {
  content: '\\E1C5';
}

.di-fitness-room::before, .di-E1C6::before {
  content: '\\E1C6';
}

.di-game::before, .di-E1C7::before {
  content: '\\E1C7';
}

.di-shuffleboard::before, .di-E1C8::before {
  content: '\\E1C8';
}

.di-parasailing::before, .di-E1C9::before {
  content: '\\E1C9';
}

.di-playground::before, .di-E1CA::before {
  content: '\\E1CA';
}

.di-horseback-riding::before, .di-E1CB::before {
  content: '\\E1CB';
}

.di-pool-tables::before, .di-E1CC::before {
  content: '\\E1CC';
}

.di-fishing::before, .di-E1CD::before {
  content: '\\E1CD';
}

.di-volleyball::before, .di-E1CE::before {
  content: '\\E1CE';
}

.di-basketball::before, .di-E1CF::before {
  content: '\\E1CF';
}

.di-cycling::before, .di-E1D0::before {
  content: '\\E1D0';
}

.di-explore::before, .di-E1D1::before {
  content: '\\E1D1';
}

.di-disneyland-recreation::before, .di-E1D2::before {
  content: '\\E1D2';
}

.di-baseball::before, .di-E1D4::before {
  content: '\\E1D4';
}

.di-field-hockey::before, .di-E1D5::before {
  content: '\\E1D5';
}

.di-football::before, .di-E1D6::before {
  content: '\\E1D6';
}

.di-gymnastics::before, .di-E1D7::before {
  content: '\\E1D7';
}

.di-lacrosse::before, .di-E1D8::before {
  content: '\\E1D8';
}

.di-crosscountry::before, .di-E1D9::before {
  content: '\\E1D9';
}

.di-soccer::before, .di-E1DA::before {
  content: '\\E1DA';
}

.di-softball-fastpitch::before, .di-E1DB::before {
  content: '\\E1DB';
}

.di-softball-slowpitch::before, .di-E1DC::before {
  content: '\\E1DC';
}

.di-track-field::before, .di-E1DD::before {
  content: '\\E1DD';
}

.di-tennis-court::before, .di-E1DE::before {
  content: '\\E1DE';
}

.di-generic-sports::before, .di-E1DF::before {
  content: '\\E1DF';
}

.di-maps::before, .di-E200::before {
  content: '\\E200';
}

.di-guest-services::before, .di-E201::before {
  content: '\\E201';
}

.di-concierge::before, .di-E202::before {
  content: '\\E202';
}

.di-resort-checkin::before, .di-E203::before {
  content: '\\E203';
}

.di-celebration::before, .di-E204::before {
  content: '\\E204';
}

.di-aeds::before, .di-E205::before {
  content: '\\E205';
}

.di-smoking-area::before, .di-E206::before {
  content: '\\E206';
}

.di-no-smoking::before, .di-E207::before {
  content: '\\E207';
}

.di-lost-found::before, .di-E208::before {
  content: '\\E208';
}

.di-baby-care-center::before, .di-E209::before {
  content: '\\E209';
}

.di-currency-exchange::before, .di-E20A::before {
  content: '\\E20A';
}

.di-atm::before, .di-E20B::before {
  content: '\\E20B';
}

.di-restrooms::before, .di-E20C::before {
  content: '\\E20C';
}

.di-first-aid::before, .di-E20D::before {
  content: '\\E20D';
}

.di-laundry::before, .di-E20E::before {
  content: '\\E20E';
}

.di-valet::before, .di-E20F::before {
  content: '\\E20F';
}

.di-in-room-babysitting::before, .di-E210::before {
  content: '\\E210';
}

.di-business-center::before, .di-E211::before {
  content: '\\E211';
}

.di-cabanas::before, .di-E212::before {
  content: '\\E212';
}

.di-ecv::before, .di-E213::before {
  content: '\\E213';
}

.di-strollers::before, .di-E214::before {
  content: '\\E214';
}

.di-parking-lot::before, .di-E215::before {
  content: '\\E215';
}

.di-kennel::before, .di-E216::before {
  content: '\\E216';
}

.di-package-pick-up::before, .di-E217::before {
  content: '\\E217';
}

.di-gas-station::before, .di-E218::before {
  content: '\\E218';
}

.di-pin-trading::before, .di-E219::before {
  content: '\\E219';
}

.di-translation-devices::before, .di-E21A::before {
  content: '\\E21A';
}

.di-wedding-ceremonies::before, .di-E21B::before {
  content: '\\E21B';
}

.di-resort-amenities::before, .di-E21C::before {
  content: '\\E21C';
}

.di-movies-under-the-stars::before, .di-E21D::before {
  content: '\\E21D';
}

.di-kodak-picture-spot::before, .di-E21E::before {
  content: '\\E21E';
}

.di-locker-rentals::before, .di-E21F::before {
  content: '\\E21F';
}

.di-here-now::before, .di-E220::before {
  content: '\\E220';
}

.di-current-location::before, .di-E221::before {
  content: '\\E221';
}

.di-supervise-children::before, .di-E222::before {
  content: '\\E222';
}

.di-rider-swap::before, .di-E223::before {
  content: '\\E223';
}

.di-service-dog::before, .di-E224::before {
  content: '\\E224';
}

.di-free-disney-wifi::before, .di-E225::before {
  content: '\\E225';
}

.di-generic-wifi::before, .di-E226::before {
  content: '\\E226';
}

.di-location-pin::before, .di-E22B::before {
  content: '\\E22B';
}

.di-disney-express-luggage::before, .di-E22D::before {
  content: '\\E22D';
}

.di-picnic-area::before, .di-E230::before {
  content: '\\E230';
}

.di-nikon-picture-spot::before, .di-E236::before {
  content: '\\E236';
}

.di-atm-2::before, .di-E237::before {
  content: '\\E237';
}

.di-drinking-fountains::before, .di-E238::before {
  content: '\\E238';
}

.di-package-express::before, .di-E239::before {
  content: '\\E239';
}

.di-kingdom-club-bellman::before, .di-E23A::before {
  content: '\\E23A';
}

.di-in-park-info::before, .di-E23B::before {
  content: '\\E23B';
}

.di-magical-coin-press-machine::before, .di-E23C::before {
  content: '\\E23C';
}

.di-stroller-parking::before, .di-E23D::before {
  content: '\\E23D';
}

.di-electric-car-charging-station::before, .di-E23E::before {
  content: '\\E23E';
}

.di-parade-route-show-area::before, .di-E23F::before {
  content: '\\E23F';
}

.di-alert::before, .di-E240::before {
  content: '\\E240';
}

.di-checkmark::before, .di-E241::before {
  content: '\\E241';
}

.di-faqs::before, .di-E242::before {
  content: '\\E242';
}

.di-quick-answer::before, .di-E243::before {
  content: '\\E243';
}

.di-disney-parks-blog::before, .di-E244::before {
  content: '\\E244';
}

.di-sms::before, .di-E245::before {
  content: '\\E245';
}

.di-press-center::before, .di-E246::before {
  content: '\\E246';
}

.di-moms-panel::before, .di-E247::before {
  content: '\\E247';
}

.di-park-schedule::before, .di-E248::before {
  content: '\\E248';
}

.di-time::before, .di-E249::before {
  content: '\\E249';
}

.di-privacy-policies::before, .di-E24A::before {
  content: '\\E24A';
}

.di-terms-conditions::before, .di-E24B::before {
  content: '\\E24B';
}

.di-accessibility::before, .di-E24C::before {
  content: '\\E24C';
}

.di-pre-arrival-tips::before, .di-E24D::before {
  content: '\\E24D';
}

.di-reservations::before, .di-E24E::before {
  content: '\\E24E';
}

.di-registration::before, .di-E24F::before {
  content: '\\E24F';
}

.di-help-support::before, .di-E250::before {
  content: '\\E250';
}

.di-learn-more::before, .di-E251::before {
  content: '\\E251';
}

.di-email::before, .di-E252::before {
  content: '\\E252';
}

.di-chat::before, .di-E253::before {
  content: '\\E253';
}

.di-call::before, .di-E254::before {
  content: '\\E254';
}

.di-14-days-notice::before, .di-E255::before {
  content: '\\E255';
}

.di-6-months-notice::before, .di-E256::before {
  content: '\\E256';
}

.di-blackout-days::before, .di-E257::before {
  content: '\\E257';
}

.di-3-days-notice::before, .di-E258::before {
  content: '\\E258';
}

.di-website-support::before, .di-E259::before {
  content: '\\E259';
}

.di-restriction::before, .di-E25A::before {
  content: '\\E25A';
}

.di-recommendation::before, .di-E25B::before {
  content: '\\E25B';
}

.di-na-dash::before, .di-E25C::before {
  content: '\\E25C';
}

.di-magic-morning::before, .di-E25D::before {
  content: '\\E25D';
}

.di-global-languages::before, .di-E25E::before {
  content: '\\E25E';
}

.di-good-neighbor-hotel::before, .di-E25F::before {
  content: '\\E25F';
}

.di-travel-information::before, .di-E261::before {
  content: '\\E261';
}

.di-visiting-with-groups::before, .di-E262::before {
  content: '\\E262';
}

.di-visiting-with-children::before, .di-E263::before {
  content: '\\E263';
}

.di-disney-like-light::before, .di-E266::before {
  content: '\\E266';
}

.di-disney-like-dark::before, .di-E267::before {
  content: '\\E267';
}

.di-written-aids::before, .di-E268::before {
  content: '\\E268';
}

.di-generations-travel::before, .di-E269::before {
  content: '\\E269';
}

.di-empty-chat::before, .di-E26A::before {
  content: '\\E26A';
}

.di-filled-chat::before, .di-E26B::before {
  content: '\\E26B';
}

.di-empty-checkbox::before, .di-E26C::before {
  content: '\\E26C';
}

.di-selected-solid-checkbox::before, .di-E26D::before {
  content: '\\E26D';
}

.di-selected-disabled::before, .di-E26E::before {
  content: '\\E26E';
}

.di-indeterminate::before, .di-E26F::before {
  content: '\\E26F';
}

.di-10-days-notice::before, .di-E270::before {
  content: '\\E270';
}

.di-wdw-ap-blockout-cal::before, .di-E271::before {
  content: '\\E271';
}

.di-flexible-ticket::before, .di-E272::before {
  content: '\\E272';
}

.di-ride-height::before, .di-E275::before {
  content: '\\E275';
}

.di-adults::before, .di-E276::before {
  content: '\\E276';
}

.di-teens-tweens::before, .di-E277::before {
  content: '\\E277';
}

.di-kids::before, .di-E278::before {
  content: '\\E278';
}

.di-price-range::before, .di-E279::before {
  content: '\\E279';
}

.di-price-range-outlined::before, .di-E27A::before {
  content: '\\E27A';
}

.di-time-outlined::before, .di-E27B::before {
  content: '\\E27B';
}

.di-all-parks-available::before, .di-E27C::before {
  content: '\\E27C';
}

.di-some-parks-available::before, .di-E27D::before {
  content: '\\E27D';
}

.di-my-media::before, .di-E280::before {
  content: '\\E280';
}

.di-images::before, .di-E281::before {
  content: '\\E281';
}

.di-videos::before, .di-E282::before {
  content: '\\E282';
}

.di-photo-pass::before, .di-E283::before {
  content: '\\E283';
}

.di-photo-pass-plus::before, .di-E284::before {
  content: '\\E284';
}

.di-media-favorites::before, .di-E285::before {
  content: '\\E285';
}

.di-photo-fun::before, .di-E286::before {
  content: '\\E286';
}

.di-disney-vision::before, .di-E287::before {
  content: '\\E287';
}

.di-dvd-cd::before, .di-E288::before {
  content: '\\E288';
}

.di-shdr-photopass::before, .di-E289::before {
  content: '\\E289';
}

.di-order-dvd::before, .di-E28B::before {
  content: '\\E28B';
}

.di-presented-in-3d::before, .di-E28C::before {
  content: '\\E28C';
}

.di-guest-photos::before, .di-E28D::before {
  content: '\\E28D';
}

.di-on-demand::before, .di-E28E::before {
  content: '\\E28E';
}

.di-live-stream::before, .di-E28F::before {
  content: '\\E28F';
}

.di-photopass-lenses::before, .di-E290::before {
  content: '\\E290';
}

.di-monorail::before, .di-E2C0::before {
  content: '\\E2C0';
}

.di-bus::before, .di-E2C1::before {
  content: '\\E2C1';
}

.di-car::before, .di-E2C2::before {
  content: '\\E2C2';
}

.di-boat::before, .di-E2C3::before {
  content: '\\E2C3';
}

.di-taxi::before, .di-E2C4::before {
  content: '\\E2C4';
}

.di-flight::before, .di-E2C5::before {
  content: '\\E2C5';
}

.di-return-flight::before, .di-E2C6::before {
  content: '\\E2C6';
}

.di-walking::before, .di-E2C7::before {
  content: '\\E2C7';
}

.di-free-shuttle::before, .di-E2C8::before {
  content: '\\E2C8';
}

.di-hkdl-mtr-disney-resort-line::before, .di-E2CE::before {
  content: '\\E2CE';
}

.di-bus-schedule::before, .di-E2CF::before {
  content: '\\E2CF';
}

.di-minnie-vans-ride-share::before, .di-E2D0::before {
  content: '\\E2D0';
}

.di-transportation-multiple::before, .di-E2D1::before {
  content: '\\E2D1';
}

.di-wdw-skylinero::before, .di-E2D2::before {
  content: '\\E2D2';
}

.di-close-button::before, .di-E300::before {
  content: '\\E300';
}

.di-add-button::before, .di-E301::before {
  content: '\\E301';
}

.di-information::before, .di-E302::before {
  content: '\\E302';
}

.di-share::before, .di-E303::before {
  content: '\\E303';
}

.di-download::before, .di-E304::before {
  content: '\\E304';
}

.di-show-filters::before, .di-E305::before {
  content: '\\E305';
}

.di-hide-filters::before, .di-E306::before {
  content: '\\E306';
}

.di-3d-spin::before, .di-E307::before {
  content: '\\E307';
}

.di-media-play-button::before, .di-E308::before {
  content: '\\E308';
}

.di-media-pause-button::before, .di-E309::before {
  content: '\\E309';
}

.di-pdf::before, .di-E30A::before {
  content: '\\E30A';
}

.di-duplicate-offer::before, .di-E30B::before {
  content: '\\E30B';
}

.di-next::before, .di-E30C::before {
  content: '\\E30C';
}

.di-previous::before, .di-E30D::before {
  content: '\\E30D';
}

.di-print::before, .di-E30F::before {
  content: '\\E30F';
}

.di-search::before, .di-E310::before {
  content: '\\E310';
}

.di-calendar-month::before, .di-E311::before {
  content: '\\E311';
}

.di-calendar-day-view::before, .di-E312::before {
  content: '\\E312';
}

.di-more::before, .di-E313::before {
  content: '\\E313';
}

.di-menu-global-nav::before, .di-E314::before {
  content: '\\E314';
}

.di-menus-button::before, .di-E315::before {
  content: '\\E315';
}

.di-norgie-opened::before, .di-E316::before {
  content: '\\E316';
}

.di-upload::before, .di-E317::before {
  content: '\\E317';
}

.di-lists::before, .di-E318::before {
  content: '\\E318';
}

.di-filter::before, .di-E319::before {
  content: '\\E319';
}

.di-scan-barcode::before, .di-E31A::before {
  content: '\\E31A';
}

.di-keyboard-entry::before, .di-E31B::before {
  content: '\\E31B';
}

.di-download-mobile-app::before, .di-E31C::before {
  content: '\\E31C';
}

.di-view-gallery::before, .di-E31D::before {
  content: '\\E31D';
}

.di-see-info-page-button::before, .di-E31E::before {
  content: '\\E31E';
}

.di-media-gallery-photo-button::before, .di-E31F::before {
  content: '\\E31F';
}

.di-media-gallery-video-button::before, .di-E320::before {
  content: '\\E320';
}

.di-refresh::before, .di-E321::before {
  content: '\\E321';
}

.di-compose-message::before, .di-E322::before {
  content: '\\E322';
}

.di-add-contact::before, .di-E323::before {
  content: '\\E323';
}

.di-contact-list::before, .di-E324::before {
  content: '\\E324';
}

.di-norgie-up::before, .di-E325::before {
  content: '\\E325';
}

.di-norgie-left::before, .di-E326::before {
  content: '\\E326';
}

.di-mobile-app::before, .di-E327::before {
  content: '\\E327';
}

.di-home::before, .di-E328::before {
  content: '\\E328';
}

.di-return-arrow::before, .di-E329::before {
  content: '\\E329';
}

.di-share-2::before, .di-E32A::before {
  content: '\\E32A';
}

.di-delete-button::before, .di-E32B::before {
  content: '\\E32B';
}

.di-fast-forward-button::before, .di-E32C::before {
  content: '\\E32C';
}

.di-rewind-button::before, .di-E32D::before {
  content: '\\E32D';
}

.di-pulldown::before, .di-E32E::before {
  content: '\\E32E';
}

.di-increase-button::before, .di-E32F::before {
  content: '\\E32F';
}

.di-decrease-button::before, .di-E330::before {
  content: '\\E330';
}

.di-flip-turn-over::before, .di-E331::before {
  content: '\\E331';
}

.di-previous-2::before, .di-E332::before {
  content: '\\E332';
}

.di-next-2::before, .di-E333::before {
  content: '\\E333';
}

.di-arrow-back::before, .di-E334::before {
  content: '\\E334';
}

.di-arrow-up::before, .di-E335::before {
  content: '\\E335';
}

.di-arrow-down::before, .di-E336::before {
  content: '\\E336';
}

.di-expand-gallery::before, .di-E337::before {
  content: '\\E337';
}

.di-360-video::before, .di-E338::before {
  content: '\\E338';
}

.di-volume-control::before, .di-E339::before {
  content: '\\E339';
}

.di-app-card-info::before, .di-E33A::before {
  content: '\\E33A';
}

.di-app-card-flip::before, .di-E33B::before {
  content: '\\E33B';
}

.di-close-reversed::before, .di-E33E::before {
  content: '\\E33E';
}

.di-expand-show-more::before, .di-E33F::before {
  content: '\\E33F';
}

.di-wheelchair-accessibility::before, .di-E340::before {
  content: '\\E340';
}

.di-transfer-from-wheelchair::before, .di-E341::before {
  content: '\\E341';
}

.di-transfer-to-wheelchair::before, .di-E342::before {
  content: '\\E342';
}

.di-transfer-to-wheelchair-then-ride::before, .di-E343::before {
  content: '\\E343';
}

.di-ambulatory::before, .di-E344::before {
  content: '\\E344';
}

.di-visual-impairment::before, .di-E345::before {
  content: '\\E345';
}

.di-hearing-impairment::before, .di-E346::before {
  content: '\\E346';
}

.di-sign-language::before, .di-E347::before {
  content: '\\E347';
}

.di-audio-description::before, .di-E348::before {
  content: '\\E348';
}

.di-handheld-captioning::before, .di-E349::before {
  content: '\\E349';
}

.di-reflective-captioning::before, .di-E34A::before {
  content: '\\E34A';
}

.di-closed-captioning::before, .di-E34B::before {
  content: '\\E34B';
}

.di-physicial-consideration-red-yellow::before, .di-E34C::before {
  content: '\\E34C';
}

.di-scary-consideration-yellow::before, .di-E34D::before {
  content: '\\E34D';
}

.di-dlp-mobility-disabilities::before, .di-E34E::before {
  content: '\\E34E';
}

.di-dlp-hearing-disabilities::before, .di-E34F::before {
  content: '\\E34F';
}

.di-dlp-visual-disabilities::before, .di-E350::before {
  content: '\\E350';
}

.di-photosensitive-epilepsy::before, .di-E351::before {
  content: '\\E351';
}

.di-dlp-mental-cognitive-disabilities::before, .di-E352::before {
  content: '\\E352';
}

.di-suitable-for-amputees::before, .di-E353::before {
  content: '\\E353';
}

.di-suitable-for-difficulty-standing::before, .di-E354::before {
  content: '\\E354';
}

.di-capable-of-climbing-steps::before, .di-E355::before {
  content: '\\E355';
}

.di-disabilities-services::before, .di-E356::before {
  content: '\\E356';
}

.di-disabilities-guide-book::before, .di-E357::before {
  content: '\\E357';
}

.di-wheelchair-rental::before, .di-E358::before {
  content: '\\E358';
}

.di-disabilities-designated-viewing::before, .di-E359::before {
  content: '\\E359';
}

.di-may-remain-in-wheelchair::before, .di-E35A::before {
  content: '\\E35A';
}

.di-must-be-ambulatory-2::before, .di-E35B::before {
  content: '\\E35B';
}

.di-suitable-for-blind::before, .di-E35C::before {
  content: '\\E35C';
}

.di-suitable-for-autism::before, .di-E35D::before {
  content: '\\E35D';
}

.di-sign-language-2::before, .di-E35E::before {
  content: '\\E35E';
}

.di-tactile-maps::before, .di-E35F::before {
  content: '\\E35F';
}

.di-braille-guide-books::before, .di-E360::before {
  content: '\\E360';
}

.di-suitable-for-learning-disabilities::before, .di-E361::before {
  content: '\\E361';
}

.di-induction-loop::before, .di-E362::before {
  content: '\\E362';
}

.di-dimly-lit-space::before, .di-E363::before {
  content: '\\E363';
}

.di-light-rain-indoors::before, .di-E364::before {
  content: '\\E364';
}

.di-show-contains-bubble::before, .di-E365::before {
  content: '\\E365';
}

.di-hdd-illness::before, .di-E366::before {
  content: '\\E366';
}

.di-open-captioning::before, .di-E367::before {
  content: '\\E367';
}

.di-magnetic-fields::before, .di-E368::before {
  content: '\\E368';
}

.di-open-captioning-square::before, .di-E369::before {
  content: '\\E369';
}

.di-gifts::before, .di-E380::before {
  content: '\\E380';
}

.di-character-calls::before, .di-E381::before {
  content: '\\E381';
}

.di-performing-arts::before, .di-E382::before {
  content: '\\E382';
}

.di-education::before, .di-E383::before {
  content: '\\E383';
}

.di-lock::before, .di-E384::before {
  content: '\\E384';
}

.di-facebook::before, .di-E385::before {
  content: '\\E385';
}

.di-twitter::before, .di-E386::before {
  content: '\\E386';
}

.di-youtube::before, .di-E387::before {
  content: '\\E387';
}

.di-instagram::before, .di-E388::before {
  content: '\\E388';
}

.di-pinterest::before, .di-E389::before {
  content: '\\E389';
}

.di-google-plus::before, .di-E38A::before {
  content: '\\E38A';
}

.di-disney-cast::before, .di-E38B::before {
  content: '\\E38B';
}

.di-disney-response::before, .di-E38C::before {
  content: '\\E38C';
}

.di-thrill-seekers::before, .di-E38E::before {
  content: '\\E38E';
}

.di-doll::before, .di-E390::before {
  content: '\\E390';
}

.di-front-desk::before, .di-E391::before {
  content: '\\E391';
}

.di-movies::before, .di-E392::before {
  content: '\\E392';
}

.di-unlocked::before, .di-E393::before {
  content: '\\E393';
}

.di-tumblr::before, .di-E394::before {
  content: '\\E394';
}

.di-services::before, .di-E395::before {
  content: '\\E395';
}

.di-old-photopass-plus::before, .di-E396::before {
  content: '\\E396';
}

.di-hkdl-sina-weibo-social::before, .di-E397::before {
  content: '\\E397';
}

.di-hkdl-baidu-tieba-social::before, .di-E398::before {
  content: '\\E398';
}

.di-hkdl-webchat-social::before, .di-E399::before {
  content: '\\E399';
}

.di-disney-wild-about-safety::before, .di-E39A::before {
  content: '\\E39A';
}

.di-romantic-celebration::before, .di-E39B::before {
  content: '\\E39B';
}

.di-facebook-icon-alone::before, .di-E39C::before {
  content: '\\E39C';
}

.di-twitter-icon-alone::before, .di-E39D::before {
  content: '\\E39D';
}

.di-snapchat::before, .di-E39E::before {
  content: '\\E39E';
}

.di-photopass-attraction-id::before, .di-E39F::before {
  content: '\\E39F';
}

.di-achievement::before, .di-E3A0::before {
  content: '\\E3A0';
}

.di-apple-music::before, .di-E3A1::before {
  content: '\\E3A1';
}

.di-apple-music-alternate::before, .di-E3A2::before {
  content: '\\E3A2';
}

.di-watches-time::before, .di-E3A3::before {
  content: '\\E3A3';
}

.di-magic-coming-soon::before, .di-E3A4::before {
  content: '\\E3A4';
}

.di-winter::before, .di-E3E4::before {
  content: '\\E3E4';
}

.di-spring::before, .di-E3E5::before {
  content: '\\E3E5';
}

.di-summer::before, .di-E3E6::before {
  content: '\\E3E6';
}

.di-autumn::before, .di-E3E7::before {
  content: '\\E3E7';
}

.di-pack-for-weather::before, .di-E3E8::before {
  content: '\\E3E8';
}

.di-single-rider::before, .di-E440::before {
  content: '\\E440';
}

.di-atm-china::before, .di-E441::before {
  content: '\\E441';
}

.di-wayfinding-slight-left::before, .di-E442::before {
  content: '\\E442';
}

.di-wayfinding-slight-right::before, .di-E443::before {
  content: '\\E443';
}

.di-wayfinding-turn-left::before, .di-E444::before {
  content: '\\E444';
}

.di-wayfinding-turn-right::before, .di-E445::before {
  content: '\\E445';
}

.di-wayfinding-hard-left::before, .di-E446::before {
  content: '\\E446';
}

.di-wayfinding-hard-right::before, .di-E447::before {
  content: '\\E447';
}

.di-wayfinding-left::before, .di-E448::before {
  content: '\\E448';
}

.di-wayfinding-right::before, .di-E449::before {
  content: '\\E449';
}

.di-wayfinding-forward::before, .di-E44A::before {
  content: '\\E44A';
}

.di-wayfinding-back::before, .di-E44B::before {
  content: '\\E44B';
}

.di-wayfinding-forward-back::before, .di-E44C::before {
  content: '\\E44C';
}

.di-wayfinding-right-left::before, .di-E44D::before {
  content: '\\E44D';
}

.di-wayfinding-around-slight-left::before, .di-E44E::before {
  content: '\\E44E';
}

.di-wayfinding-around-slight-right::before, .di-E44F::before {
  content: '\\E44F';
}

.di-wayfinding-around-turn-left::before, .di-E450::before {
  content: '\\E450';
}

.di-wayfinding-around-turn-right::before, .di-E451::before {
  content: '\\E451';
}

.di-wayfinding-around-hard-left::before, .di-E452::before {
  content: '\\E452';
}

.di-wayfinding-around-hard-right::before, .di-E453::before {
  content: '\\E453';
}

.di-wayfinding-around-left::before, .di-E454::before {
  content: '\\E454';
}

.di-wayfinding-around-right::before, .di-E455::before {
  content: '\\E455';
}

.di-wayfinding-around-forward-left::before, .di-E456::before {
  content: '\\E456';
}

.di-wayfinding-around-forward-right::before, .di-E457::before {
  content: '\\E457';
}

.di-wayfinding-u-turn-right::before, .di-E458::before {
  content: '\\E458';
}

.di-wayfinding-u-turn-left::before, .di-E459::before {
  content: '\\E459';
}

.di-wayfinding-ramp-left::before, .di-E45A::before {
  content: '\\E45A';
}

.di-wayfinding-ramp-right::before, .di-E45B::before {
  content: '\\E45B';
}

.di-wayfinding-fork-left::before, .di-E45C::before {
  content: '\\E45C';
}

.di-wayfinding-fork-right::before, .di-E45D::before {
  content: '\\E45D';
}

.di-wayfinding-around-about-left::before, .di-E45E::before {
  content: '\\E45E';
}

.di-wayfinding-around-about-right::before, .di-E45F::before {
  content: '\\E45F';
}

.di-wayfinding-merge::before, .di-E460::before {
  content: '\\E460';
}

.di-cribs-and-playpens::before, .di-E461::before {
  content: '\\E461';
}

.di-baby-care-center2::before, .di-E462::before {
  content: '\\E462';
}

.di-epi-pen::before, .di-E463::before {
  content: '\\E463';
}

.di-mobile-charging-station::before, .di-E464::before {
  content: '\\E464';
}

.di-security-info::before, .di-E465::before {
  content: '\\E465';
}

.di-refrigerator-available::before, .di-E466::before {
  content: '\\E466';
}

.di-repellant-zika::before, .di-E467::before {
  content: '\\E467';
}

.di-hurricane-information::before, .di-E468::before {
  content: '\\E468';
}

.di-recenter-map::before, .di-E46A::before {
  content: '\\E46A';
}

.di-location-pin::before, .di-E46C::before {
  content: '\\E46C';
}

.di-transportation-parking-info::before, .di-E46D::before {
  content: '\\E46D';
}

.di-resort-automatic-check-out::before, .di-E46E::before {
  content: '\\E46E';
}

.di-service-your-way::before, .di-E46F::before {
  content: '\\E46F';
}

.di-direct-to-room::before, .di-E470::before {
  content: '\\E470';
}

.di-premium-service-shdr::before, .di-E471::before {
  content: '\\E471';
}

.di-virtual-queue::before, .di-E472::before {
  content: '\\E472';
}

.di-energy-monster::before, .di-E473::before {
  content: '\\E473';
}

.di-elevators::before, .di-E475::before {
  content: '\\E475';
}

.di-salon::before, .di-E476::before {
  content: '\\E476';
}

.di-clothing::before, .di-E480::before {
  content: '\\E480';
}

.di-accessories::before, .di-E481::before {
  content: '\\E481';
}

.di-home-office::before, .di-E482::before {
  content: '\\E482';
}

.di-toys-games::before, .di-E483::before {
  content: '\\E483';
}

.di-art-collectibles::before, .di-E484::before {
  content: '\\E484';
}

.di-entertainment::before, .di-E485::before {
  content: '\\E485';
}

.di-health-beauty::before, .di-E486::before {
  content: '\\E486';
}

.di-sweets::before, .di-E487::before {
  content: '\\E487';
}

.di-play-logo::before, .di-E4C0::before {
  content: '\\E4C0';
}

.di-rocket-race-game::before, .di-E4C1::before {
  content: '\\E4C1';
}

.di-peter-pan-s-flight-game::before, .di-E4C2::before {
  content: '\\E4C2';
}

.di-toy-story-mania-game::before, .di-E4C3::before {
  content: '\\E4C3';
}

.di-trivia-games::before, .di-E4C4::before {
  content: '\\E4C4';
}

.di-esmeralda-quest::before, .di-E4C5::before {
  content: '\\E4C5';
}

.di-fortune-red-quest::before, .di-E4C6::before {
  content: '\\E4C6';
}

.di-temple-of-mara-decoder::before, .di-E4C7::before {
  content: '\\E4C7';
}

.di-conservation-fund-quest::before, .di-E4C8::before {
  content: '\\E4C8';
}

.di-soarin-challenge::before, .di-E4C9::before {
  content: '\\E4C9';
}

.di-agent-p-challenge::before, .di-E4CA::before {
  content: '\\E4CA';
}

.di-fun-wheel-challenge::before, .di-E4CB::before {
  content: '\\E4CB';
}

.di-andy-s-game-board-blast::before, .di-E4CC::before {
  content: '\\E4CC';
}

.di-art-of-animation::before, .di-E4CD::before {
  content: '\\E4CD';
}

.di-flight-of-passage::before, .di-E4CE::before {
  content: '\\E4CE';
}

.di-dlr-magic-mural::before, .di-E4CF::before {
  content: '\\E4CF';
}

.di-splash-mountain::before, .di-E4D0::before {
  content: '\\E4D0';
}

.di-kidcot-challenge::before, .di-E4D1::before {
  content: '\\E4D1';
}

.di-swge-millenium-falcon::before, .di-E4D2::before {
  content: '\\E4D2';
}

.di-swge-star-destroyer::before, .di-E4D3::before {
  content: '\\E4D3';
}

.di-swge-bso-logo::before, .di-E4D4::before {
  content: '\\E4D4';
}

.di-add-stepper::before, .di-E500::before {
  content: '\\E500';
}

.di-reduce-stepper::before, .di-E501::before {
  content: '\\E501';
}

.di-hide-collapse::before, .di-E502::before {
  content: '\\E502';
}

.di-mute-volume::before, .di-E503::before {
  content: '\\E503';
}

.di-unmute-volume::before, .di-E504::before {
  content: '\\E504';
}

.di-filter-items::before, .di-E505::before {
  content: '\\E505';
}

.di-forward-thin::before, .di-E506::before {
  content: '\\E506';
}

.di-back-thin::before, .di-E507::before {
  content: '\\E507';
}

.di-fast-fwd-thin::before, .di-E508::before {
  content: '\\E508';
}

.di-rewind-thin::before, .di-E509::before {
  content: '\\E509';
}

.di-download-thin::before, .di-E50A::before {
  content: '\\E50A';
}

.di-facial-opt-in-off::before, .di-E50B::before {
  content: '\\E50B';
}

.di-facial-opt-in-on::before, .di-E50C::before {
  content: '\\E50C';
}

.di-bluetooth::before, .di-E518::before {
  content: '\\E518';
}

.di-norgie-closed::before, .di-E534::before {
  content: '\\E534';
}

.di-fastpass-order-shopping-bag-plus::before, .di-E540::before {
  content: '\\E540';
}

.di-fastpass-order-shopping-bag::before, .di-E542::before {
  content: '\\E542';
}

.di-shdr-ticket-annualpass::before, .di-E544::before {
  content: '\\E544';
}

.di-tickets-outlined::before, .di-E54B::before {
  content: '\\E54B';
}

.di-early-entry-pass::before, .di-E54C::before {
  content: '\\E54C';
}

.di-disney-card-member::before, .di-E54D::before {
  content: '\\E54D';
}

.di-club-33-dlr-member::before, .di-E54E::before {
  content: '\\E54E';
}

.di-shdr-ap-activation::before, .di-E54F::before {
  content: '\\E54F';
}

.di-disney-maxpass-alternate::before, .di-E550::before {
  content: '\\E550';
}

.di-ap-activation::before, .di-E552::before {
  content: '\\E552';
}

.di-standby-pass::before, .di-E553::before {
  content: '\\E553';
}

.di-early-park-entry-pass::before, .di-E554::before {
  content: '\\E554';
}

.di-mobile-checkout::before, .di-E555::before {
  content: '\\E555';
}

.di-disney-premier-access-global::before, .di-E556::before {
  content: '\\E556';
}

.di-disney-premier-access-secondary::before, .di-E557::before {
  content: '\\E557';
}

.di-disney-premier-access-new::before, .di-E558::before {
  content: '\\E558';
}

.di-golden-oak-resident::before, .di-E559::before {
  content: '\\E559';
}

.di-disability-access-service::before, .di-E55A::before {
  content: '\\E55A';
}

.di-lightning-lane::before, .di-E55B::before {
  content: '\\E55B';
}

.di-disney-plus::before, .di-E55C::before {
  content: '\\E55C';
}

.di-enchant-key::before, .di-E55D::before {
  content: '\\E55D';
}

.di-dream-key::before, .di-E55E::before {
  content: '\\E55E';
}

.di-imagine-key::before, .di-E55F::before {
  content: '\\E55F';
}

.di-believe-key::before, .di-E560::before {
  content: '\\E560';
}

.di-unused-character::before, .di-F8FE::before {
  content: '\\F8FE';
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('wdpr-mdx-icons');
